import { useUsers } from "../../../context/UserContext";
import { updateUser } from "../../../lib/api/users";

export function useUserSettings() {
  const { currentUser, refreshUsers, emit } = useUsers();

  const updateWorkStartDay = async (value: string) => {
    if (!currentUser) return;

    const updatedUser = {
      ...currentUser,
      app: {
        ...currentUser.app,
        weekStartsOn: value,
      },
    };

    const { password, ...userWithoutPassword } = updatedUser;

    try {
      await updateUser(currentUser.id, userWithoutPassword);
      await refreshUsers();
      emit("settingsUpdated", {
        userId: currentUser.id,
        settings: updatedUser.settings,
        app: updatedUser.app,
      });
    } catch (error) {
      console.error("Failed to update work start day:", error);
      throw error;
    }
  };

  const updateWeekNumberSetting = async (value: "left" | "right" | "none") => {
    if (!currentUser) return;

    const updatedUser = {
      ...currentUser,
      settings: {
        ...currentUser.settings,
        showWeekNumber: value,
      },
    };

    const { password, ...userWithoutPassword } = updatedUser;

    try {
      await updateUser(currentUser.id, userWithoutPassword);
      await refreshUsers();
      emit("settingsUpdated", {
        userId: currentUser.id,
        settings: updatedUser.settings,
        app: updatedUser.app,
      });
    } catch (error) {
      console.error("Failed to update week number setting:", error);
      throw error;
    }
  };

  const updateShowWerklijstenSetting = async (value: boolean) => {
    if (!currentUser) return;

    const updatedUser = {
      ...currentUser,
      settings: {
        ...currentUser.settings,
        showWerklijsten: value,
      },
    };

    const { password, ...userWithoutPassword } = updatedUser;

    try {
      await updateUser(currentUser.id, userWithoutPassword);
      await refreshUsers();
      emit("settingsUpdated", {
        userId: currentUser.id,
        settings: updatedUser.settings,
        app: updatedUser.app,
      });
    } catch (error) {
      console.error("Failed to update show werklijsten setting:", error);
      throw error;
    }
  };

  const updateShowColleagueHolidayRequestsSetting = async (value: boolean) => {
    if (!currentUser) return;

    const updatedUser = {
      ...currentUser,
      settings: {
        ...currentUser.settings,
        showColleagueHolidayRequests: value,
      },
    };

    const { password, ...userWithoutPassword } = updatedUser;

    try {
      await updateUser(currentUser.id, userWithoutPassword);
      await refreshUsers();
      emit("settingsUpdated", {
        userId: currentUser.id,
        settings: updatedUser.settings,
        app: updatedUser.app,
      });
    } catch (error) {
      console.error("Failed to update show colleague holiday requests setting:", error);
      throw error;
    }
  };

  return {
    currentUser,
    updateWorkStartDay,
    updateWeekNumberSetting,
    updateShowWerklijstenSetting,
    updateShowColleagueHolidayRequestsSetting,
  };
}
